import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";

import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();
  const [contactType, useContactType] = useState("engineer");

  function handleClick(event) {
    navigate("/contact-us", { state: { contactType } });
  }

  return (
      <div className="b-container">
        <div className="ready-text">Ready to Start Your Project?</div>
        <div className="discuss">
          Let's discuss how we can help you achieve your business goals with
          innovative software solutions.
        </div>

        <div className="double-button">
          <div className="hire-button">
            <button className="nav-link get-touch" onClick={handleClick}>
              Get in Touch{" "}
              <span className="arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="#000"
                    d="M8.85 3.15a.5.5 0 0 0-.707.707l4.15 4.15h-9.79a.5.5 0 0 0 0 1h9.79l-4.15 4.15a.5.5 0 0 0 .707.707l5-5a.5.5 0 0 0 0-.707l-5-5z"
                  ></path>
                </svg>
              </span>
            </button>
          </div>

          <div className="hire-button">
            {/* <button className="nav-link contact" id="portfolio">
              View Our Portfolio
            </button> */}

            <NavHashLink className="nav-link contact" to="/#portfolio">
              <span className="portfolio-link">Portfolio</span>
            </NavHashLink>
          </div>
        </div>
      </div>
  );
};
export default Banner;
